import { Modal, ModalProps } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useCompanyInformationForm } from '../contexts/companyInformationFormContext'
import { ModalBody } from './ModalBody'
import { ModalFooter } from './ModalFooter'

export const CompanyInformationModalComponent = (modalProps: ModalProps): ReactElement => {
  const { t } = useTranslation()
  const { isProcessing } = useCompanyInformationForm()

  return (
    <Modal {...modalProps} size="s" closable={!isProcessing}>
      <Modal.Header title={t('external_invoices.company_information_modal.title')} />
      <Modal.Body>
        <ModalBody />
      </Modal.Body>
      <Modal.Footer>
        <ModalFooter />
      </Modal.Footer>
    </Modal>
  )
}
